import { SetStateAction } from 'react';
import {
  ASSIGN_RANDOM_CM,
  ReportStatus,
  UPDATE_STATUS,
  UpdateReport,
} from 'src/api';
import axios from 'src/axios';
import { handleErrorToast, handleSuccessToast } from 'src/components/molecules';
import { toastEventBus } from 'src/components/molecules/Toast/toastEventBus';

export const submitAndAssignRandomCM = async (
  currentReport: UpdateReport,
  setRedirect: (value: SetStateAction<boolean>) => void,
  shouldAssignRandomCM: boolean = false,
  status?: string,
) => {
  try {
    toastEventBus.clear();
    const id = currentReport.report!;
    if (shouldAssignRandomCM) {
      await axios.post(ASSIGN_RANDOM_CM(id), {
        id,
        status: status ?? ReportStatus.NEW,
      });
    } else {
      await axios.put(UPDATE_STATUS(id), {
        id,
        status: status ?? ReportStatus.NEW,
      });
    }
    handleSuccessToast({
      toastMessage: 'Case manager assigned and report submitted',
    });
    setRedirect(true);
  } catch (errors) {
    handleErrorToast({
      toastMessage: `Failed to complete submit${
        shouldAssignRandomCM ? ` and random assign case manager.` : `.`
      }`,
    });
  }
};
